const content: { [key: string]: any } = {
  platformDetail: 'Platform Detail',
};

export default content;
